export default __webpack_public_path__ + "static/media/Security.305a474b.svg";